"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("@ikea-aoa/utilities");
/**
 * This class is used for transforming data ÖVERSÄTTA translation tool.
 */
var OversattaTransformer = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param [options.localizationPrefixApplication] Localization prefix application.
     * @param options.locale Locale.
     */
    function OversattaTransformer(options) {
        this.localizationPrefixApplication = null;
        this.locale = null;
        this.localizationPrefixApplication = options.localizationPrefixApplication || null;
        this.locale = options.locale;
    }
    /**
     * Transforms data into a LocalizedInformation model.
     *
     * @param data Response data to parse.
     * @returns Localized information model.
     */
    OversattaTransformer.prototype.transform = function (data) {
        var storeId = data.localization && data.localization.storeId ? data.localization.storeId : null;
        var langId = data.localization && data.localization.langId ? data.localization.langId : null;
        var localizedInformation = {
            localization: this.getLocalization(data.localization || {}),
            priceSettings: (data['priceSettings'] || data.prices || {}),
            urls: this.getUrls(data['urls'] || data.URLs || {}, storeId, langId),
            endpoints: this.getEndpoints(data.endpoints || {}),
            translations: this.getTranslations(data.translations || {})
        };
        for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
            var key = _a[_i];
            if (!localizedInformation[key] &&
                key !== 'iconImages' &&
                key !== 'prices' &&
                key !== 'URLs') {
                localizedInformation[key] = data[key];
            }
        }
        return localizedInformation;
    };
    /**
     * Parses localization.
     *
     * @param localization Localization.
     * @returns Parsed localization.
     */
    OversattaTransformer.prototype.getLocalization = function (localization) {
        var newLocalization = Object.assign({}, localization);
        var application = this.localizationPrefixApplication;
        if (application) {
            for (var _i = 0, _a = Object.keys(localization); _i < _a.length; _i++) {
                var key = _a[_i];
                var pairs = key.split('__');
                if (pairs.length > 1 && pairs[0] === application) {
                    newLocalization[pairs[1]] = localization[key];
                }
                if (pairs.length > 1) {
                    delete newLocalization[key];
                }
            }
        }
        // We should not use these.
        // Instead we should take the locale from the URL, or use endpoints.
        delete newLocalization['locale'];
        delete newLocalization['iowsLocalePath'];
        delete newLocalization['countryCode'];
        delete newLocalization['languageCode'];
        return newLocalization;
    };
    /**
     * Parses translations.
     *
     * @param translations Translations.
     * @returns Parsed translations.
     */
    OversattaTransformer.prototype.getTranslations = function (translations) {
        var newTranslations = {};
        for (var _i = 0, _a = Object.keys(translations); _i < _a.length; _i++) {
            var key = _a[_i];
            newTranslations[this.snakeToCamelCase(key)] = translations[key];
        }
        return newTranslations;
    };
    /**
     * Parses URL:s.
     *
     * @param urls URL:s.
     * @param storeId Store id.
     * @param langId Langauge id.
     * @returns Parsed URL:s.
     */
    OversattaTransformer.prototype.getUrls = function (urls, storeId, langId) {
        var _a = utilities_1.LocaleUtility.getCountryAndLanguage(this.locale), country = _a.country, language = _a.language;
        var newUrls = {};
        for (var _i = 0, _b = Object.keys(urls); _i < _b.length; _i++) {
            var key = _b[_i];
            newUrls[key] = urls[key]
                .replace('{country}', country)
                .replace('{language}', language)
                .replace('{storeId}', storeId)
                .replace('{langId}', langId);
        }
        return newUrls;
    };
    /**
     * Parses endpoints.
     *
     * @param endpoints Endpoints.
     * @returns Parsed endpoints.
     */
    OversattaTransformer.prototype.getEndpoints = function (endpoints) {
        var _a = utilities_1.LocaleUtility.getCountryAndLanguage(this.locale), country = _a.country, language = _a.language;
        var newEndpoints = {};
        for (var _i = 0, _b = Object.keys(endpoints); _i < _b.length; _i++) {
            var key = _b[_i];
            newEndpoints[key] = endpoints[key]
                .replace('{country}', country)
                .replace('{language}', language)
                .replace('{retailUnit}', country.toUpperCase())
                .replace('{locale}', this.locale);
        }
        return newEndpoints;
    };
    /**
     * Formats a lower camel case string into upper snake case (translation key).
     *
     * @param string String to format.
     * @returns Formatted string.
     */
    OversattaTransformer.prototype.snakeToCamelCase = function (string) {
        if (/[^A-Z0-9_]/.test(string)) {
            return string;
        }
        return string
            .toLowerCase()
            .replace(/([_][a-z0-9])/gi, function (chars) { return chars.toUpperCase().replace('_', ''); });
    };
    return OversattaTransformer;
}());
exports.default = OversattaTransformer;
//# sourceMappingURL=OversattaTransformer.js.map